'use strict';

var core = require('core/components/slider');
var tinySlider = require('tiny-slider/src/tiny-slider');

var SiteConstants = require('constants/SiteConstants');
var mediumBreakpoint = SiteConstants.BreakpointSizes.sm;
var largeBreakpoint = SiteConstants.BreakpointSizes.lg;
var XLbreakpoint = SiteConstants.BreakpointSizes.xl;

// Override core to change tabindex to 0 for accessibility focusing
core.applyTinySlider = function ($container, params) {
    if (!$container) return;

    var tabsContainer = $('.nav-tabs-container');
    if($container.closest(tabsContainer) && $container.closest(tabsContainer).length > 0) {
        $container.closest(tabsContainer).find('.tab-pane').not('.active').addClass('no-active-tab');
    }

    var tslider = tinySlider.tns(params);

    var isBRCarousel = $container.parents().hasClass('bloomreach-widget-recommendations');
    if(isBRCarousel) {
        $container.find('.tns-slider').css('width','');
    }

    if (!!tslider) {
        tslider.events.on('transitionStart', this.slideIntoView);

        this.bindPauseButton($container, tslider);
        this.bindSliderUpdateEvent($container, tslider);
        this.enableImageZoom($container);
        this.handleThumbnailArrows($container, tslider);
        this.handleSliderVideos($container, tslider);

        $('body').trigger('slider:init.sliderEvents', [$container]);
    }

    $container.data('tns', tslider);
    $container.trigger('tooltip:init');

    core.getSliderA11y($container);
    core.redirectToPDP();

    tabsContainer.find('.nav-link').on('click', function() {
        var tabPane = $(this).closest(tabsContainer).find('.tab-pane');
        tabPane.addClass('no-active-tab');
        var thisTabpaneID = $(this).attr('href');
        $(thisTabpaneID).removeClass('no-active-tab');
    });
    var handleImgStack = $container.has('.handle-image-stacked-js');
    if (handleImgStack.length) {
        var firstSlideDisplay = handleImgStack.find('.slide:first').css('display');
        handleImgStack.find('.slide').not(':first-child').css('display', firstSlideDisplay);
    }

    // Add class if slider has a Next button
    var controls = $container.find('.tns-controls');
    if (controls.css('display') !== 'none' && controls.find('[data-controls="next"]')) {
        $container.addClass('has-next-button-js');
    }
}

/**
 * Adds accessibility attributes (ARIA roles, labels, tabindex) to slider controls.
 * Ensures visibility-based accessibility for navigation buttons and controls.
 *
 * @param {jQuery} $container - The slider container element.
 */
core.getSliderA11y = function ($container) {
    var controlsEle = $container.find('.tns-controls');
    var navControls = $container.find('.tns-nav');
    var titleEle = $container.parent().find('.slider-title');

    // Get the carousel title, if available
    var carouselTitle = (titleEle && titleEle.length) ? titleEle.text().trim() + '-' : '';

    var prevEle = controlsEle.find('[data-controls="prev"]');
    var nextEle = controlsEle.find('[data-controls="next"]');

    var allControls = $().add(controlsEle).add(navControls.find('button:not(.tns-nav-active)'));

    /**
     * Sets tabindex and role="presentation" based on element visibility.
     * 'tns-controls' elements are always excluded from tab order.
     *
     * @param {jQuery} elements - A jQuery collection of elements to process.
     */
    function controlsVisibleCheckADA(elements) {
        elements.each(function () {
            const $el = $(this);
            const commonAttrs = {
                'tabindex': $el.is(':visible') ? '0' : '-1',
                'role': 'presentation'
            };
    
            if ($el.hasClass('tns-controls')) {
                commonAttrs.tabindex = '-1';
            }
    
            $el.attr(commonAttrs);
        });
    }

    /**
     * Applies ARIA roles, labels, and tabindex for screen readers
     * @param {Array} elements - Array of [element, label] pairs
     * @param {string} carouselTitle - Optional title prefix for labels
     */
    function setAttributesFromArray(elements, carouselTitle) {
        elements.forEach(([ele, btnText]) => {
            if (!ele || !btnText) return;

            var $ele = $(ele);
            var existingLabel = controlsEle && controlsEle.attr('aria-label') || '';
            var labelPrefix = existingLabel ? existingLabel.trim() + ': ' : '';
            var ariaLabelText = (carouselTitle + labelPrefix + btnText).trim();

            $ele.attr({
                'aria-label': ariaLabelText,
                'role': 'button',
                'tabindex': $ele.is(':visible') ? 0 :'-1'
            });
        });
    }

    // Initialize accessibility attributes for all control elements
    controlsVisibleCheckADA(allControls);
    setAttributesFromArray([[prevEle, 'Previous'], [nextEle, 'Next']], carouselTitle);
}

core.redirectToPDP = function() {
    var sliderContainer = $('.slider-container');
    var tile = sliderContainer.find('.product-tile');
    if(tile && tile.length) {
        tile.find('.price-container .price').on('click', function() {
            window.location.href = $(this).closest('.price-container').attr('pdp-url');
        });
    }
};

// Replaces rvw_autobahn_core
// Build parameter object to create a slider
core.getSliderParams = function($slider, slideItems) {
    var attributes = core.getSliderAttributes($slider);
    var params = {
        container: $slider.find('.slider')[0],
        loop: attributes.loop,
        items: attributes.items,
        autoplay: attributes.autoplay,
        autoplayTimeout: attributes.autoplayTimeout,
        autoplayHoverPause: true,
        mode: attributes.mode,
        gutter: attributes.gutter,
        speed: attributes.speed,
        navContainer: attributes.navContainer,
        navAsThumbnails: attributes.navAsThumbnails,
        controlsContainer: attributes.controlsContainer,
        preventScrollOnTouch: 'auto', // prevents mobile errors in chrome
        swipeAngle: 50,
        autoHeight: attributes.autoHeightSmall,
        responsive: {
            [mediumBreakpoint]: {
                items: attributes.itemsMedium,
                gutter: attributes.gutterMedium,
                autoHeight: attributes.autoHeightMedium,
            },
            [largeBreakpoint]: {
                items: attributes.itemsLarge,
                gutter: attributes.gutterLarge,
            },
            [XLbreakpoint]: {
                items: attributes.itemsXL
            }
        }
    }

    if (slideItems) {
        params.slideItems = slideItems;
    }

    if (params.mode === 'gallery') {
        params.animateIn = attributes.animateIn;
        params.animateOut = attributes.animateOut;
    }

    return params;
}

module.exports = core;